<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <div class="card">
        <div class="card-body" [formGroup]="formGroup">
          <div class="row">
            <div class="form-group col-md-2 col-12">
              <label for="code">{{ "CODE" | translate }}<sup class="text-danger">*</sup></label>
              <input placeholder="C3" type="text" id="code" class="form-control {{fieldHasErrors('code') ? 'is-invalid' : ''}}" formControlName="code" />
              <div class="invalid-feedback" *ngIf="formGroup.controls?.code?.errors?.required">{{ "ERRORS.FIELD_CODE" | translate }}</div>
              <div class="invalid-feedback" *ngIf="formGroup.controls?.code?.errors?.minlength ">{{ "MIN" | translate }} 2 {{ 'CHARACTERS' | translate }}</div>
              <div class="invalid-feedback" *ngIf="formGroup.controls?.code?.errors?.maxlength ">{{ "MAX" | translate }} 5 {{ 'CHARACTERS' | translate }}</div>
            </div>
            <div class="form-group col-md-5 col-12">
              <label for="name">{{ "FIRSTNAME" | translate }}<sup class="text-danger">*</sup></label>
              <input placeholder="{{'NAME'|translate}}" type="text" id="name" class="form-control {{fieldHasErrors('name') ? 'is-invalid' : ''}}" formControlName="name" />
              <div class="invalid-feedback" *ngIf="formGroup.controls?.name?.errors?.required">{{ "ERRORS.FIELD_NAME" | translate }}</div>
              <div class="invalid-feedback" *ngIf="formGroup.controls?.name?.errors?.minlength ">{{ "MIN" | translate }} 2 {{ 'CHARACTERS' | translate }}</div>
              <div class="invalid-feedback" *ngIf="formGroup.controls?.name?.errors?.maxlength ">{{ "MAX" | translate }} 255 {{ 'CHARACTERS' | translate }}</div>
            </div>
            <div class="form-group col-md-5 col-12">
              <label for="type">{{ "TYPE_ABSENCE" | translate }}<sup class="text-danger">*</sup></label>
              <ng-select formControlName="type" id="type" bindLabel="name" class="{{fieldHasErrors('type') ? 'is-invalid' : ''}}" [searchable]="true" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true">
                <ng-option *ngFor="let typeOfAbsence of _absencesService.typeAbsence" [value]="typeOfAbsence">{{ "TYPE_ABSENCES." + typeOfAbsence| translate }}</ng-option>
              </ng-select>
              <div class="invalid-feedback" *ngIf="formGroup.controls.type.errors?.required">{{ "ERRORS.FIELD_TYPE_ABSENCE" | translate }}</div>
            </div>
            <div class="form-group col-md-6 col-12">
              <div class="custom-control custom-control-primary custom-switch">
                <small class="mr-1">{{ "ABSENCE_REQUIRE_NOTE" | translate }}</small>
                <input type="checkbox" class="custom-control-input" id="require_note" formControlName="require_note" />
                <label class="custom-control-label" for="require_note"></label>
              </div>
            </div>
            <div class="form-group col-md-6 col-12">
              <div class="custom-control custom-control-primary custom-switch">
                <small class="mr-1" [ngClass.sm]="'mr-025'">{{ "ABSENCE_REQUIRE_FILE" | translate }}</small>
                <input type="checkbox" class="custom-control-input" id="require_file" formControlName="require_file" />
                <label class="custom-control-label" for="require_file"></label>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer text-right">
          <button type="button" [routerLink]="'/dashboard/absences-type-list'" rippleEffect class="btn btn-outline-secondary mr-1">{{ 'BACK' | translate }}</button>
          <button type="submit" rippleEffect class="btn btn-primary mr-1" (click)="isEdit ? update() : create()">{{ 'SAVE' | translate }}</button>
        </div>
      </div>
    </section>
  </div>
</div>